var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "info_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#info_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 28.333h3.334v-10h-3.334v10ZM20 15c.472 0 .868-.16 1.188-.48.319-.319.479-.714.479-1.187 0-.472-.16-.868-.48-1.187-.319-.32-.715-.48-1.187-.48-.472 0-.868.16-1.188.48-.319.32-.479.715-.479 1.187 0 .473.16.868.48 1.188.319.32.715.479 1.187.479Zm0 21.667c-2.305 0-4.472-.438-6.5-1.313-2.028-.875-3.792-2.062-5.292-3.562S5.521 28.528 4.646 26.5 3.333 22.305 3.333 20c0-2.306.438-4.472 1.313-6.5.875-2.028 2.062-3.792 3.562-5.292s3.264-2.687 5.292-3.562 4.195-1.313 6.5-1.313c2.306 0 4.472.438 6.5 1.313 2.028.875 3.792 2.062 5.292 3.562s2.687 3.264 3.562 5.292 1.313 4.194 1.313 6.5c0 2.305-.438 4.472-1.313 6.5-.875 2.028-2.062 3.792-3.562 5.292s-3.264 2.687-5.292 3.562-4.194 1.313-6.5 1.313Zm0-3.334c3.722 0 6.875-1.291 9.458-3.875 2.584-2.583 3.875-5.736 3.875-9.458 0-3.722-1.291-6.875-3.875-9.458C26.875 7.958 23.722 6.667 20 6.667c-3.722 0-6.875 1.291-9.458 3.875C7.958 13.125 6.667 16.278 6.667 20c0 3.722 1.291 6.875 3.875 9.458 2.583 2.584 5.736 3.875 9.458 3.875Z"
}))));
export default SvgInfo;